import type { WeeklyHoursFormDefinition } from "./weekly-hours-types";

export const WEEKLY_HOURS_FORMS: WeeklyHoursFormDefinition[] = [
  {
    kind: "energy",
    label: "Energy",
    description: "Junior banker weekly deal hours",
    aliases: ["GIB/Energy/Junior Banker View"],
  },
  {
    kind: "energy-si",
    label: "Energy SI",
    description: "Summer internship weekly deal hours",
    aliases: ["GIB/Energy/SI Junior Banker View"],
  },
  {
    kind: "technology",
    label: "Technology",
    description: "Technology banker time log",
    aliases: ["GIB/Technology SF/Junior Banker View", "GIB/Technology NY/Junior Banker View", "gibtech"],
  },
  {
    kind: "power",
    label: "PU&I",
    description: "Power, Utilities & Infrastructure time log",
    aliases: ["GIB/PU&I/Junior Banker View", "power_analyst"],
  },
  {
    kind: "cme",
    label: "CME",
    description: "Weekly deal tracker",
    aliases: ["CME", "CMEWidgetUser"],
  },
  {
    kind: "real-estate",
    label: "Real Estate",
    description: "Daily worklog by deal",
    aliases: ["Real Estate", "REWidgetUser"],
  },
  {
    kind: "consumer-retail",
    label: "Consumer & Retail",
    description: "Member weekly time log",
    aliases: ["Consumer And Retail", "consumerRegular"],
  },
  {
    kind: "gpc",
    label: "GPC",
    description: "Global Private Capital weekly time log",
    aliases: ["GPC", "gpc"],
  },
  {
    kind: "energy-staffer",
    label: "Energy staffer",
    description: "Revise analyst and associate deal hours",
    aliases: ["GIB/Energy/Staffer View"],
  },
  {
    kind: "energy-si-staffer",
    label: "Energy SI staffer",
    description: "Revise summer intern deal hours",
    aliases: ["GIB/Energy/SI Staffer View"],
  },
];

function normalize(value: string): string {
  return value.trim().toLocaleLowerCase();
}

export function resolveWeeklyHoursForms(subDepartments: string[]): WeeklyHoursFormDefinition[] {
  const names = new Set(subDepartments.filter(Boolean).map(normalize));
  const canSeeAll = names.has("all") || names.has("allrbc");

  return WEEKLY_HOURS_FORMS.filter((form) => canSeeAll || form.aliases.some((alias) => names.has(normalize(alias))));
}
